import React, { useEffect, useState } from 'react';

export interface PaymentChannelLogoProps {
  code?: string | null;
  name?: string | null;
}

// Logos live in public/assets/channels/<code>.png. A channel without a logo file used to
// render a broken image with the raw code (e.g. "other_qris") as alt text, so fall back
// to the channel's name instead.
export const PaymentChannelLogo: React.FC<PaymentChannelLogoProps> = ({ code, name }) => {
  const [missing, setMissing] = useState(!code);
  const label = name || code || '-';

  useEffect(() => setMissing(!code), [code]);

  if (missing) {
    return <span className='text-sm'>{label}</span>;
  }

  return (
    <img
      src={`/assets/channels/${code!.toLowerCase()}.png`}
      className='w-20 rounded-md'
      alt={label}
      title={label}
      onError={() => setMissing(true)}
    />
  );
};
